// Mirror of BILLING_CATEGORIES in packages/shared. apps/web cannot import that package (ADR 0019) --
// it builds locally and then fails Azure Static Web Apps' isolated build. Keep the two identical.
export const BILLING_CATEGORIES = ['PS', 'R&D', 'License', 'Hosting', 'MA'];

// Shown for a milestone whose category was never set -- only reachable for rows created after the
// backfill, since that set every existing one to PS.
export const UNCATEGORIZED = 'Uncategorized';

// The Milestone Tracker opens on delivery work only (Judy, 2026-09-16), plus uncategorized rows so a
// milestone nobody has categorized yet isn't hidden by default (Judy, 2026-10-29).
export const DEFAULT_BILLING_CATEGORY_FILTER = ['PS', 'R&D', UNCATEGORIZED];

// Mirror of VALUE_TYPES in packages/shared (ADR 0019 again). Whether the money is certain, which is
// a separate question from what kind of work it is.
export const VALUE_TYPES = ['Committed', 'Draw-down', 'Optional'];
export const CONTINGENT_VALUE_TYPES = ['Draw-down', 'Optional'];
export const DEFAULT_VALUE_TYPE = 'Committed';
// The one a billed-as-used pot can be tied to (ADR 0046) -- see DRAWDOWN_VALUE_TYPE in shared.
export const DRAWDOWN_VALUE_TYPE = 'Draw-down';
